;(() => {
  const qAll = (sel, root) => Array.from((root || document).querySelectorAll(sel))

  const initThemeCarousel = root => {
    // Theme-provided initializer (T4SThemeSP.Carousel) for .flickityt4s
    if (!window.T4SThemeSP || !T4SThemeSP.Carousel) return false
    const carousels = qAll('.flickityt4s', root)
    carousels.forEach(el => {
      if (el.classList.contains('flickityt4s-enabled')) return
      try {
        el.flickityt4s = new T4SThemeSP.Carousel(el)
      } catch (e) {
        console.warn('[slider] theme carousel init failed', e)
      }
    })
    return carousels.length > 0
  }

  const initFallback = root => {
    // Only when theme initializer is unavailable
    const sliders = qAll('.t4s-flicky-slider', root)
    sliders.forEach(slider => {
      // Skip if theme already enabled flickityt4s
      if (slider.closest('.flickityt4s-enabled')) return
      if (slider.__fallbackInit) return
      slider.__fallbackInit = true

      slider.style.overflowX = 'auto'
      slider.style.scrollBehavior = 'smooth'
      slider.style.display = 'grid'
      slider.style.gridAutoFlow = 'column'
      const colsDesktop = parseInt(slider.getAttribute('data-cols-desktop') || '1', 10)
      const colsTablet = parseInt(slider.getAttribute('data-cols-tablet') || slider.getAttribute('data-cols') || String(colsDesktop), 10)
      const colsMobile = parseInt(slider.getAttribute('data-cols-mobile') || '1', 10)
      const applyCols = () => {
        const w = window.innerWidth
        const cols = w >= 1024 ? colsDesktop : w >= 768 ? colsTablet : colsMobile
        slider.style.gridAutoColumns = `${100 / Math.max(1, cols)}%`
      }
      applyCols()
      slider.style.scrollSnapType = 'x mandatory'
      qAll(':scope > *', slider).forEach(cell => {
        cell.style.scrollSnapAlign = 'start'
      })

      const wrapper = slider.parentElement
      if (!wrapper) return
      const makeBtn = (cls, label, side) => {
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = `t4s-fallback-${cls}`
        btn.setAttribute('aria-label', label)
        Object.assign(btn.style, {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: '2',
          width: '36px',
          height: '36px',
          borderRadius: '9999px',
          border: '0',
          background: 'rgba(17,24,39,.6)',
          color: '#fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          [side]: '8px'
        })
        btn.innerHTML = cls === 'prev' ? '&#8249;' : '&#8250;'
        return btn
      }
      const prev = makeBtn('prev', 'Previous', 'left')
      const next = makeBtn('next', 'Next', 'right')

      const container = document.createElement('div')
      container.style.position = 'relative'
      wrapper.insertBefore(container, slider)
      container.appendChild(slider)
      container.appendChild(prev)
      container.appendChild(next)

      const scrollBy = dir => {
        const w = slider.clientWidth
        slider.scrollLeft += dir * w
      }
      prev.addEventListener('click', () => scrollBy(-1))
      next.addEventListener('click', () => scrollBy(1))
      const onResize = () => applyCols()
      window.addEventListener('resize', onResize, { passive: true })
    })
  }

  const wireNavButtons = root => {
    // Wire up external nav buttons to sliders
    const wrappers = qAll('.t4s-media-carousel__wrapper', root)
    wrappers.forEach(wrap => {
      const slider = q('.t4s-media-carousel__slider', wrap)
      const prev = q('.t4s-carousel-nav--prev', wrap)
      const next = q('.t4s-carousel-nav--next', wrap)
      if (!slider || !prev || !next) return
      if (prev.__navWired) return
      prev.__navWired = true
      next.__navWired = true

      const scrollBy = dir => {
        // Get first cell width + gap
        const cell = q('.t4s-media-cell', slider)
        if (!cell) return
        const cellWidth = cell.offsetWidth
        const gap = 20 // match CSS gap
        const scrollAmount = cellWidth + gap
        slider.scrollBy({
          left: dir * scrollAmount,
          behavior: 'smooth'
        })
      }
      prev.addEventListener('click', () => scrollBy(-1))
      next.addEventListener('click', () => scrollBy(1))
    })
  }

  const boot = root => {
    // Try theme first; fallback only if theme API missing
    const ok = initThemeCarousel(root)
    if (!ok && (!window.T4SThemeSP || !T4SThemeSP.Carousel)) {
      initFallback(root)
    }
    wireNavButtons(root)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot())
  } else {
    boot()
  }
  document.addEventListener('shopify:section:load', e => boot(e.target))
})()


